/**
 * Pulse Launcher entry point.
 *
 * Pulls in cross-product styles (brand tokens + shell chrome) before mounting
 * the React tree so first paint already has the canonical look-and-feel.
 */

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "@pulse-business-ai/brand-tokens/styles.css";
import "@pulse-business-ai/shell/styles.css";

import App from "./App.js";

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("pulse-launcher: #root element missing from index.html");
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
